import { render, staticRenderFns } from "./dashboardExamenes.vue?vue&type=template&id=958e3078&scoped=true&"
import script from "./dashboardExamenes.vue?vue&type=script&lang=js&"
export * from "./dashboardExamenes.vue?vue&type=script&lang=js&"
import style0 from "./dashboardExamenes.vue?vue&type=style&index=0&id=958e3078&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958e3078",
  null
  
)

export default component.exports